// convert number to type thousand
function numberFormatToThousand(x) {
    if(!x) return "0"
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export default numberFormatToThousand